<div class="container">
    <svg version="1.1" baseProfile="full" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.2rem" cy="2.2rem" r="2.0rem" fill="white" stroke="lightblue" stroke-width="0.4rem"/>
        <line x1="2.2rem" y1="2.2rem" [attr.x2]="minutesHandX" [attr.y2]="minutesHandY" style="stroke:lightblue;stroke-width:0.4rem" />
        <line x1="2.2rem" y1="2.2rem" [attr.x2]="secondsHandX" [attr.y2]="secondsHandY" style="stroke:lightblue;stroke-width:0.4rem" />
        <circle cx="2.2rem" cy="2.2rem" r="0.2rem" fill="lightblue"/>
    </svg>
    <div class="countdown-text" [class.infinity]="timeSeconds === 9999">{{formattedTime}}</div>
</div>
